var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayslipOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_edcad9fc1695cce98c9e02076973d5b8f3bb493a669a91010ad0965d3b70807f",
    x1: 51.456,
    y1: 27.299,
    x2: 68.804,
    y2: 27.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M35.078 54.869v.052M24.048 40.238h33.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M54.974 47.838s-.35-2.013-2.015-2.011-2.111 2.015-2.111 2.015l4.327 3.275"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M51.051 51.12s.35 2.013 2.015 2.011c1.665-.002 2.111-2.015 2.111-2.015M53.008 44.112l.001 1.714M53.016 53.131l.001 1.715M47.839 47.838s-.35-2.013-2.015-2.011-2.111 2.015-2.111 2.015l4.327 3.275"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M43.915 51.12s.35 2.013 2.015 2.011c1.665-.002 2.111-2.015 2.111-2.015M45.872 44.112l.002 1.714M45.881 53.131l.001 1.715M40.585 47.838s-.35-2.013-2.015-2.011-2.111 2.015-2.111 2.015l4.327 3.275"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M36.661 51.12s.35 2.013 2.015 2.011c1.665-.002 2.111-2.015 2.111-2.015M38.618 44.112l.002 1.714M38.626 53.131l.002 1.715M33.45 47.838s-.35-2.013-2.015-2.011-2.111 2.015-2.111 2.015l4.327 3.275"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M29.526 51.12s.35 2.013 2.015 2.011c1.665-.002 2.111-2.015 2.111-2.015M31.483 44.112l.001 1.714M31.491 53.131l.002 1.715"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.979 37.129v22.819H20.361V16.386M31.462 5.285h29.517v8.035"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M31.463 5.285l-11.1 11.1h11.1v-11.1zM52.892 33.592v.784H27.985V21.275h21.362M49.817 29.969H28.036M48.688 25.682H28.036M37.063 21.568v12.594"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 60.507,
    cy: 24.886,
    r: 11.566
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M69.425 36.698l2.893-2.894 9.92 9.92-2.893 2.894zM68.707 33.22l2.01 1.803"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M68.179 28.413A8.44 8.44 0 1152.87 21.3",
    stroke: "url(#SVGID_0_edcad9fc1695cce98c9e02076973d5b8f3bb493a669a91010ad0965d3b70807f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslipOverview);
export default __webpack_public_path__ + "static/media/payslipOverview.10ae08161d21ae8412979bdc2c5abf55.svg";
export { ForwardRef as ReactComponent };